import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { UserAuthService } from '../services/user-auth.service';

@Injectable({ providedIn: 'root' })
export class UnfinishedLoginGuard implements CanActivate, OnDestroy {

  private readonly onPageShow = (event: PageTransitionEvent) => {
    if (event.persisted && this.isOnRegistrationPage() && this.hasUnfinishedLogin()) {
      this.endUnfinishedLogin();
    }
  };

  constructor(
    private readonly router: Router,
    private readonly userAuthService: UserAuthService,
    private readonly spinner: NgxSpinnerService
  ) {
    globalThis.addEventListener('pageshow', this.onPageShow);
  }

  ngOnDestroy() {
    globalThis.removeEventListener('pageshow', this.onPageShow);
  }

  canActivate(): boolean {
    if (this.cameBackThroughHistory() && this.hasUnfinishedLogin()) {
      this.endUnfinishedLogin();
      return false;
    }
    return true;
  }

  private cameBackThroughHistory(): boolean {
    if (this.router.getCurrentNavigation()?.trigger === 'popstate') {
      return true;
    }
    return !this.router.navigated && this.documentLoadedFromHistory();
  }

  private documentLoadedFromHistory(): boolean {
    const entry = performance.getEntriesByType?.('navigation')?.[0] as PerformanceNavigationTiming | undefined;
    return entry?.type === 'back_forward';
  }

  private hasUnfinishedLogin(): boolean {
    return !!this.userAuthService.getAccessToken() && sessionStorage.getItem('cellVerificationDone') !== 'true';
  }

  private isOnRegistrationPage(): boolean {
    const path = this.router.url.split(/[?#]/)[0];
    return path === '/register' || path === '/' || path === '';
  }

  private endUnfinishedLogin() {
    this.spinner.show();
    this.userAuthService.logOutWhenReady();
  }
}
